module.exports = __webpack_public_path__ + "img/qrcode.8a18af73.png";